import React from "react";

import { CoreProps } from "./util";
import AutoSortGrid, { AutoSortProps } from "./AutoSortGrid";
import GridImpl, { ImplProps, ImplSortProps } from "./GridImpl";

export { type GridColumn, type CellData } from "./util";

export { NumberCell, MsCell, BytesCell, NoDataGridContainer } from "./GridImpl";

type SortProps<T> =
  | (AutoSortProps<T> & { handleSort?: never })
  | (ImplSortProps<T> & { defaultSortBy?: never });

type Props<T> = CoreProps<T> & SortProps<T>;

function Grid<T>(props: Props<T>) {
  // If we're dealing with an external sort, just pass through the props.
  // Otherwise, use a wrapper that will handle sorting
  if ("handleSort" in props) {
    return <GridImpl {...(props as ImplProps<T>)} />;
  }

  return <AutoSortGrid {...props} />;
}

export default Grid;
